import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

export type TValidPriorityGroupKeys =
  | 'ONE_TERM_AWAY'
  | 'TWO_TERMS_AWAY'
  | 'THREE_TERMS_AWAY'
  | 'FOUR_TERMS_AWAY'
  | 'PLANNED_BEYOND_4'
  | 'PLANNED_NON_GRAD'
  | 'PLAN_INCOMPLETE'
  | 'NONE';

export interface IPriorityGroupDefinition {
  key: TValidPriorityGroupKeys;
  priorityVal: number;
  priorityLabel: string;
  studentPriorityGroupingValue: string;
  plannedGradDateFilter?: string;
}

export class RegentsPlanningPriorityGroupingsTransferService {
  static $inject: string[] = ['Rollbar', 'ImSchool'];

  constructor(private Rollbar, private ImSchool: ImSchool) {}

  private next4GradDates = this.ImSchool.getNextFourGradDatesForTransfer();
  private oneTermAway = this.next4GradDates[0];
  private twoTermsAway = this.next4GradDates[1];
  private threeTermsAway = this.next4GradDates[2];
  private fourTermsAway = this.next4GradDates[3];

  private _priorityGroupings: IPriorityGroupDefinition[] = [
    {
      key: 'ONE_TERM_AWAY',
      priorityVal: 1,
      priorityLabel: `Planned ${this.oneTermAway.humanName} Grads with unaddressed Regents needs.`,
      studentPriorityGroupingValue: `1. Planned ${this.oneTermAway.humanName} Grad w/ Unaddressed Regents Needs`,
      plannedGradDateFilter: this.oneTermAway.humanName,
    } as IPriorityGroupDefinition,

    {
      key: 'TWO_TERMS_AWAY',
      priorityVal: 2,
      priorityLabel: `Planned ${this.twoTermsAway.humanName} Grads with unaddressed Regents needs.`,
      studentPriorityGroupingValue: `2. Planned ${this.twoTermsAway.humanName} Grad w/ Unaddressed Regents Needs`,
      plannedGradDateFilter: this.twoTermsAway.humanName,
    } as IPriorityGroupDefinition,

    {
      key: 'THREE_TERMS_AWAY',
      priorityVal: 3,
      priorityLabel: `Planned ${this.threeTermsAway.humanName} Grads with unaddressed Regents needs.`,
      studentPriorityGroupingValue: `3. Planned ${this.threeTermsAway.humanName} Grad w/ Unaddressed Regents Needs`,
      plannedGradDateFilter: this.threeTermsAway.humanName,
    } as IPriorityGroupDefinition,

    {
      key: 'FOUR_TERMS_AWAY',
      priorityVal: 4,
      priorityLabel: `Planned ${this.fourTermsAway.humanName} Grads with unaddressed Regents needs.`,
      studentPriorityGroupingValue: `4. Planned ${this.fourTermsAway.humanName} Grad w/ Unaddressed Regents Needs`,
      plannedGradDateFilter: this.fourTermsAway.humanName,
    } as IPriorityGroupDefinition,

    {
      key: 'PLANNED_BEYOND_4',
      priorityVal: 5,
      priorityLabel: `Planned to graduate beyond ${this.fourTermsAway.humanName} with unaddressed Regents needs.`,
      studentPriorityGroupingValue: `5. Planned Beyond ${
        this.fourTermsAway.humanName
      } Grad w/ Unaddressed Regents Needs`,
      plannedGradDateFilter: `Beyond ${this.fourTermsAway.humanName}`,
    } as IPriorityGroupDefinition,

    {
      key: 'PLANNED_NON_GRAD',
      priorityVal: 6,
      priorityLabel: 'Planned Non-Graduates with unaddressed Regents needs.',
      studentPriorityGroupingValue: '6. Planned Non-Grad w/ Unaddressed Regents Needs',
      plannedGradDateFilter: 'Planned Non-Grad',
    } as IPriorityGroupDefinition,

    {
      key: 'PLAN_INCOMPLETE',
      priorityVal: 7,
      priorityLabel: 'Students with incomplete grad plans with unaddressed Regents needs.',
      studentPriorityGroupingValue: '7. No Grad Plan w/ Unaddressed Regents Needs',
      plannedGradDateFilter: 'Plan Incomplete',
    } as IPriorityGroupDefinition,

    {
      key: 'NONE',
      priorityVal: 8,
      priorityLabel: 'Students with no unaddressed Regents needs.',
      studentPriorityGroupingValue: 'No Unaddressed Regents Needs',
      plannedGradDateFilter: 'None',
    } as IPriorityGroupDefinition,
  ];

  private _getPriorityGroupByKey(key: TValidPriorityGroupKeys): IPriorityGroupDefinition {
    return _.find(this._priorityGroupings, { key });
  }

  public getStudentValueForPriorityGroupByKey(key: TValidPriorityGroupKeys): string {
    const prioirtyGroup = this._getPriorityGroupByKey(key);
    return prioirtyGroup.studentPriorityGroupingValue;
  }

  public getPriorityGroupsByPlannedGradDateFilter(plannedGradDateFilter?): IPriorityGroupDefinition[] {
    return plannedGradDateFilter
      ? (_.filter(this._priorityGroupings, { plannedGradDateFilter }) as IPriorityGroupDefinition[])
      : this._priorityGroupings;
  }
}
